import { Avatar } from "@amzn/awsui-chat-components";
import React from "react";

import { ChatMessageAuthor } from "./types";

export type ChatAvatarProps = ChatMessageAuthor;

const ChatAvatar: React.FC<ChatAvatarProps> = ({
  type,
  name,
  initials,
  loading,
}) =>
  type === "gen-ai" ? (
    <Avatar
      color="gen-ai"
      iconName="gen-ai"
      tooltipText={name}
      ariaLabel={name || "Gen AI"}
      loading={loading}
    />
  ) : (
    <Avatar initials={initials} tooltipText={name} ariaLabel={name || ""} />
  );

export default ChatAvatar;
